<template>
  <div class="card shadow-1 q-px-lg">
    <div style="text-align: start">
      <h3 style="font-size: 20px; gap: 10px;" class="flex">
         {{$gettext('BILLINGS')}}
      </h3>
    </div>
    <header-colapse-invoices :count="dataTable.length" @colapse="isOpen = !isOpen">
      <span class="tw-font-bold tw-text-lg tw-text-white">{{ $gettext('BILLINGS') }}</span>
    </header-colapse-invoices>
    <div v-if="isOpen" style="color: #c1c1c1; overflow-x: auto;" class="flex flex-center column tw-overflow-hidden tw-flex-1 tw-w-full tw-h-full">
      <jt-data-table
      v-if="dataColumns"
        id="jt-composition"
        :api-mode="false"
        :data="dataTable"
        :fields="dataColumns.columns"
        :is-paginated="false"
        row-buttons
        noneselect
        @action-button="actionButton"
        :class="!data && 'tw-mt-6'"
        class="tw-flex-1 tw-w-full"
        style="overflow-x: auto; width: 100%;"
      >
       <template #body="{props}">
      <q-tr class="text-left">
        <q-td v-for="col in props.cols.filter(col => {return col.type != 'HIDDEN'})" :key="col.name" :props="props" style="color: #333">
            <span v-if="col.name === 'agreementInvoiceStatusDesc'">
              {{ formatLateStatusIfNecessary(props.cols,col.value) }}
            </span>
            <span v-else-if="col.name === 'amortization' || col.name === 'feesAfterDiscount'
            || col.name === 'fineAfterDiscount' || col.name === 'correctionAfterDiscount'
            || col.name === 'correctedValue'">
              {{ $toLocaleStringBr(col.value) }}
            </span>
            <span v-else>
              {{ col.value }}
            </span>
         </q-td>
        </q-tr>
    </template>
    </jt-data-table>
    </div>

  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'src/jtech'
import { JtDataTable } from 'jtech-webcomps'
import HeaderColapseInvoices from './HeaderColapseInvoices.vue'
@Component({
  name: 'Invoices',
  components: {
    JtDataTable,
    HeaderColapseInvoices
  },
  props: {
    data: Object
  }
})
class Invoices extends Vue {
  nmInterface = 'invoiceDocumentSearches.pesquisarInvoiceAgreementInvoice'
  dataColumns = {};
  dataTable = [];
  isOpen = true;

  async mounted () {
    this.dataColumns = await repository.resolveDatatable(
      this.nmInterface
    )
    const result = await repository.resolveDatatableModel(
      this.nmInterface,
      { agreementInvoice: this.data.id }
    )
    this.dataTable = result.registros
  }
}
export default Invoices

</script>
<style scoped>
.card {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
